import { render } from "./UpdateInfo.vue?vue&type=template&id=430bc30e&scoped=true&ts=true"
import script from "./updateInfoHelper.ts?vue&type=script&lang=ts"
export * from "./updateInfoHelper.ts?vue&type=script&lang=ts"

import "./UpdateInfo.vue?vue&type=style&index=0&id=430bc30e&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-430bc30e"]])

export default __exports__